import { ServiceError as IServiceError } from 'proto/eshop/BasketService_pb_service'
import i18n from 'i18n'
import { grpc } from '@improbable-eng/grpc-web'

export class ServiceError extends Error implements Omit<IServiceError, 'metadata'> {
	message: string
	code: number = grpc.Code.Unknown
	name: string = i18n.gettext('Error')

	constructor(message: string, code?: number) {
		super(message)
		this.message = message
		if (code) this.code = code
	}

	static create(error: { message: string, code: number }): ServiceError {
		return new ServiceError(error.message, error.code)
	}
}
